import CityLandingPage from './page';

const ribeiraoPretoData = {
  cityName: 'Ribeirão Preto',
  state: 'SP',
  slug: 'palestra-silenciosa-ribeirao-preto',
  coordinates: { lat: -21.1767, lng: -47.8202 },
  phone: '(11) 91777-6227',
  localKeywords: [
    'palestra silenciosa ribeirao preto',
    'silent conference ribeirao preto sp',
    'aluguel fones sem fio ribeirao preto',
    'eventos corporativos ribeirao preto',
    'tradução simultânea ribeirao preto',
    'festa silenciosa ribeirao preto',
  ],
  heroTitle: 'palestra silenciosa ribeirão preto',
  heroSubtitle: 'Tecnologia de áudio sem fio premium para eventos corporativos, conferências e workshops em Ribeirão Preto. Capital do agronegócio e polo de saúde com suporte técnico especializado.',
  localStats: { clients: '75+', satisfaction: '97%' },
  localTestimonials: [],
  localFAQs: [
    { question: 'Vocês atendem toda a região de Ribeirão Preto?', answer: 'Sim! Atendemos Ribeirão Preto e cidades vizinhas como Sertãozinho, Franca, Jaboticabal, São Carlos, Araraquara e toda a macrorregião. Nossa equipe cobre um raio de 150km com agilidade.' },
    { question: 'Qual o prazo de antecedência para eventos em Ribeirão Preto?', answer: 'Recomendamos 2 a 3 semanas para eventos em Ribeirão Preto. Durante a Agrishow e outros grandes eventos do calendário, sugerimos reservar com 1 mês de antecedência devido à alta demanda.' },
    { question: 'Vocês têm experiência com congressos médicos em Ribeirão Preto?', answer: 'Sim! Ribeirão Preto é referência em saúde e já realizamos diversos congressos médicos na cidade. Nossos fones têm qualidade de áudio excepcional, ideal para palestras técnicas e tradução simultânea em eventos da área da saúde.' },
    { question: 'Quantos fones sem fio posso alugar em Ribeirão Preto?', answer: 'Atendemos de pequenos simpósios (30 fones) a grandes congressos (350+ fones) em Ribeirão Preto. Todo equipamento é higienizado e testado antes de cada evento.' },
    { question: 'Os equipamentos funcionam bem nos centros de convenções de Ribeirão Preto?', answer: 'Perfeitamente! Conhecemos bem o Centro de Convenções de Ribeirão Preto, o RibeirãoShopping Events e os principais hotéis corporativos. O sistema funciona com alcance de 100m sem interferência.' },
  ],
  seoTitle: 'Ribeirão Preto Palestra Silenciosa | Aluguel Fones Sem Fio SP | STIB',
  seoDescription: 'Palestra silenciosa Ribeirão Preto: aluguel de fones sem fio para eventos corporativos, congressos médicos e feiras do agronegócio. Tecnologia premium. Solicite orçamento!',
  relatedCities: [
    { name: 'São Paulo (Capital)', slug: '/sao-paulo', region: 'Capital' },
    { name: 'Campinas', slug: '/campinas', region: 'Região Metropolitana' },
    { name: 'Barueri / Alphaville', slug: '/barueri', region: 'Grande SP Oeste' },
    { name: 'São José dos Campos', slug: '/sao-jose-dos-campos', region: 'Vale do Paraíba' },
    { name: 'Santos', slug: '/santos', region: 'Baixada Santista' },
    { name: 'Guarulhos', slug: '/guarulhos', region: 'Grande SP Leste' },
    { name: 'São Bernardo do Campo', slug: '/sao-bernardo-do-campo', region: 'ABCD Paulista' },
    { name: 'Jundiaí', slug: '/jundiai', region: 'Interior Oeste' },
  ],
};

export default function RibeiraoPretoLandingPage() {
  return <CityLandingPage cityData={ribeiraoPretoData} />;
}